import { render, staticRenderFns } from "./articleClassify.vue?vue&type=template&id=172ea014"
import script from "./articleClassify.vue?vue&type=script&lang=js"
export * from "./articleClassify.vue?vue&type=script&lang=js"
import style0 from "./articleClassify.vue?vue&type=style&index=0&id=172ea014&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports